import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardTitle, CardDescription } from './Card'
import { cn } from '@/lib/utils'
import { ArrowRight } from 'lucide-react'
import { LocalizedLink } from '@/components/LocalizedLink'

interface ProductCardProps {
  title: string
  description: string
  imageSrc: string
  imageHoverSrc?: string
  to: string
  className?: string
}

export function ProductCard({
  title,
  description,
  imageSrc,
  to,
  className,
}: ProductCardProps) {
  const { t } = useTranslation()
  const [, setIsHovered] = useState(false)

  return (
    <LocalizedLink to={to} className="block group">
      <Card
        variant="hover"
        className={cn('h-full relative overflow-hidden', className)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Hover bar at top */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-primary transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left z-10" />

        <div className="relative aspect-[4/3] overflow-hidden">
          {/* Color image with zoom on hover */}
          <img
            src={imageSrc}
            alt={title}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-normal group-hover:scale-[1.15]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-dark/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-normal" />
        </div>
        <CardContent className="flex flex-col flex-grow">
          <CardTitle className="group-hover:text-primary transition-colors">
            {title}
          </CardTitle>
          <CardDescription className="flex-grow">{description}</CardDescription>
          <div className="mt-4 flex items-center text-primary font-medium">
            <span>{t('buttons.learnMore')}</span>
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
          </div>
        </CardContent>
      </Card>
    </LocalizedLink>
  )
}
